import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import INota from '../../types/INota';
import axiosInstance from '../../utils/axiosInstance';

interface NotaState {
  loading: boolean;
  error: string | null;
}

const initialState: NotaState = {
  loading: false,
  error: null,
};

// Salva l'elenco delle note
export const saveNote = createAsyncThunk(
  'nota/saveNote',
  async (newNote: INota[], { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post(`/nota`, newNote);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message ?? 'Errore durante il salvataggio delle note');
    }
  }
);

const notaSlice = createSlice({
  name: 'nota',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //* Salva l'elenco delle note
      .addCase(saveNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNote.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'Failed to update note';
      });
  },
});

export default notaSlice.reducer;
